import { Redirect } from "expo-router";

export default function AuthIndexWeb() {
    return <Redirect href="/" />;
} 